<template>
    <div>
        <p class="control" v-if="projectRegistrationsOnSpecificDate().length == 0">
            <input v-model.number="weekTime" @keyup.enter="addRegistration()" class="input is-small" type="number" min=0 max=24 step="0.5" v-bind:class="{ halfWidth: weekTime }">
            <span v-if="weekTime">
                <input type="button" :value="$t('input.save')" v-if="weekTime <= 24 && weekTime > 0 && showSaveButton" @click="addRegistration()" class="button is-small is-primary is-outlined is-pulled-right">
                <a v-else class="button is-small is-danger is-outlined is-pulled-right" disabled>{{$t("input.error")}}</a>
            </span>
        </p>
    </div>
</template>

<script>
import firebase from '@/firebase'
import moment from 'moment'
import _ from 'lodash'

export default {
  name: 'TimeWeekInputEmpty',
  components: {
  },
  props: {
    weekDate: String,
    weekProject: String,
    weekProjectNo: String,
    weekProjectLine: String,
  },
    data: function() {
    return {
      weekTime: 0,
      allRegistrationsOnSpecificDate: [],
      showSaveButton:true,
    }
  },
    firebase: function() { 
      const tenantid = JSON.parse(localStorage.getItem('profile')).tenantid;
      const userid = JSON.parse(localStorage.getItem('profile')).user_id;
      return {
          orgSettings: {
            source: firebase.database().ref('/organisations/' + tenantid + '/settings'),
            asObject: true,
        },
      }
    },
  watch: {
    '$route' (to, from) {
      // when route changes
      const tenantid = JSON.parse(localStorage.getItem('profile')).tenantid;
      firebase.auth().onAuthStateChanged(function(user) {
        if (user) {
          this.user = user
          this.$bindAsArray('allRegistrationsOnSpecificDate', firebase.database().ref('/organisations/' + tenantid + '/registrations/' + user.uid).orderByChild('date').equalTo(this.weekDate));
          // TODO: resetting weekTime also resets for original input
          this.weekTime = 0;
        }
      }.bind(this))
    }
  },
  beforeCreate: function() {
    // Setup Firebase onAuthStateChanged handler
    const tenantid = JSON.parse(localStorage.getItem('profile')).tenantid;
    firebase.auth().onAuthStateChanged(function(user) {
      if (user) {
        this.user = user
        this.$bindAsArray('allRegistrationsOnSpecificDate', firebase.database().ref('/organisations/' + tenantid + '/registrations/' + user.uid).orderByChild('date').equalTo(this.weekDate));
      }
    }.bind(this))
  },
  methods: {
    projectRegistrationsOnSpecificDate: function() {
      return _.filter(this.allRegistrationsOnSpecificDate, { 'projectCombined': this.weekProject, 'date': this.weekDate})
    },
    addRegistration: function() {
        if (this.weekTime > 0) {
          const tenantid = JSON.parse(localStorage.getItem('profile')).tenantid;
          const userid = JSON.parse(localStorage.getItem('profile')).user_id;
          let update = {
                  project: this.weekProjectNo,
                  projectLine: this.weekProjectLine,
                  projectCombined: this.weekProject,
                  uid: userid,
                  tenantid: tenantid,
                  date: this.weekDate,
                  time: this.weekTime,
                  quarter: moment(this.weekDate).quarter(),
                  isApproved: false,
                  sentForApproval: false,
                  timestamp: moment().format()
              }
              if (this.orgSettings.ERPenabled === false) {
                update.isCustomProject = true
              } 
          this.$firebaseRefs.allRegistrationsOnSpecificDate.push(update);
          //hide save button
          this.showSaveButton = false;
        } else if (this.weekTime == 0) {
          console.log("lig med 0")
        }
    },
  }
}
</script>
